

































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ItemWithLink from '@/components/molecules/ItemWithLink.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ItemKind } from '@/models/item/kind'
import { CartPageURL } from '@spa/components/pages/cart/model/Cart'

import HalfModal from './HalfModal.vue'

@Component({
  components: {
    HalfModal,
    ItemWithLink,
  },
})
export default class CartInSuccessModal extends Vue {
  @Prop({ required: true })
  brandEnglishName: string

  @Prop({ default: () => [] })
  recommendItems: any[]

  get itemKind(): ItemKind {
    return BehaviorConfig.createFromBrand(this.brandEnglishName).itemList.layout
  }

  moveToCart(): void {
    location.href = CartPageURL.forBrand(
      this.brandEnglishName,
      { isCartIn: 'true' }
    ).href
  }
}
